(function($) {

	'use strict';

	var init = function() {

        if($('.fp-news').length > 0) {       
            startNewsSlider();
        }

    }

    var startNewsSlider = function() {

        var newsSlider = $('.news-slider');

        $(window).resize(function() {
            
            if($(window).width() < 768) {

                $('.news-slider').addClass('owl-carousel').addClass('owl-theme');

                newsSlider.owlCarousel({
                    
                    loop: false,
                    margin: 10,
                    nav: false,
                    items: 1,
                    autoWidth: true,
                    dots: true,
                    center: true,
                    stagePadding: 0,
                    dotsEach: 1
                });

            } else {

                newsSlider.owlCarousel('destroy');

                $('.news-slider').removeClass('owl-carousel').removeClass('owl-theme');

            }
            
        }).resize(); 

    }

	$(document).ready(function() {
		init();
	});

})(jQuery);